import { render, staticRenderFns } from "./preViewModal.vue?vue&type=template&id=27813a13&scoped=true&"
import script from "./preViewModal.vue?vue&type=script&lang=js&"
export * from "./preViewModal.vue?vue&type=script&lang=js&"
import style0 from "./preViewModal.vue?vue&type=style&index=0&id=27813a13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27813a13",
  null
  
)

export default component.exports